<template>
  <v-list two-line dense>
    <v-subheader>Pipeline</v-subheader>
    <div v-if="inque.length > 0 ">
      <template v-for="item in inque">
        <v-list-item :key="item.id">
          <v-list-item-avatar>
            <v-icon color="orange">fas fa-shower</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium">
              {{ item.workorder.name }}
            </v-list-item-title>
            <v-list-item-subtitle>
              <WorkOrderNavigation :instance="item.workorder" />
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-list-item-action-text>Rank {{ item.priority }}</v-list-item-action-text>
            <ToolProcessVote :upvote="true" :processid="item.id" :current-priority="item.priority" />
            <ToolProcessVote :upvote="false" :processid="item.id" :current-priority="item.priority" />
          </v-list-item-action>
        </v-list-item>
      </template>
    </div>
    <div v-else>
      <v-list-item>
        <v-list-item-avatar>
          <v-icon color="primary">fas fa-sad-tear</v-icon>
        </v-list-item-avatar>
        <v-list-item-content class="primary--text">
          <v-list-item-title>
            Nothing in the Pipeline
          </v-list-item-title>
          <v-list-item-subtitle>
            Navigate to a relevant workorder and add it to the que.
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </div>
  </v-list>
</template>

<script>
import ToolProcess from "../../models/ToolProcess";
import ToolProcessVote from "./ToolProcessVote";
import WorkOrderNavigation from "../WorkOrders/WorkOrderNavigation";
export default {
  name: "ToolProcessInQueList",
  components: {WorkOrderNavigation, ToolProcessVote},
  props: {
    toolid: {
      type: [Number, String],
      required: true
    }
  },
  computed: {
    inque() {
      return ToolProcess.query()
        .where("tool_id", parseInt(this.toolid))
        .where("in_que", true)
        .with("workorder")
        .orderBy("priority", "desc")
        .get();
    }
  }
}
</script>
